import { Pipe, PipeTransform } from '@angular/core';
@Pipe({
  name: 'filterFatorAvaliado'
})
export class FilterFatorPipe implements PipeTransform {

  transform(items: any[], searchText: string): any[] {
    if (!items) { return []; }
    if (!searchText) { return items; }

    searchText = searchText.toLowerCase();
    return items.filter(it => {
      return it.nomeFator.toLowerCase().includes(searchText);
    });
  }

}
